import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PropertyCard from '../components/PropertyCard';
import { propertiesAPI } from '../../services/api.service';
import LocationAutoSuggest from '../../components/LocationAutoSuggest/LocationAutoSuggest';
import '../styles/Filteredproperties.css';
import '../styles/BuyerSearchBar.css';
import BuyerSearchBar from '../components/BuyerSearchBar';
import UpcomingProjectsSection from "../components/UpcomingProjectCard";
import homephoto from "../../assets/project_banner.jpeg";
const CityProjects = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const cityParam = searchParams.get('city');
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);
  // SearchBar state
  const [searchData, setSearchData] = useState({
    location: '',
    propertyType: '',
    budget: '',
    bedrooms: ''
  });

  const propertyTypes = ['Apartment', 'Villa', 'Plot', 'Commercial',"PG / Hostel","Independent House","Row House","Bungalow","Studio Apartment","Penthouse","Farm House","Industrial N/A Land ","Plot / Land","Commercial Office","Commercial Shop","Retail Space","Warehouse / Godown","Industrial Property","Hotel / Guest House",];
  const bedroomOptions = ['1', '2', '3', '4', '5+'];
  const budgetRanges = [
    '0-25L',
    '25L-50L',
    '50L-75L',
    '75L-1Cr',
    '1Cr-2Cr',
    '2Cr+'
  ];

  const topCities = [
    'Mumbai',
    'Delhi',
    'Bangalore',
    'Hyderabad',
    'Ahmedabad',
    'Chennai',
    'Kolkata',
    'Pune',
    'Jaipur',
    'Surat'
  ];

  // SearchBar handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();


    
    // Build query string
    const queryParams = new URLSearchParams();
    if (searchData.location) queryParams.append('location', searchData.location);
    if (searchData.propertyType) queryParams.append('type', searchData.propertyType);
    if (searchData.budget) queryParams.append('budget', searchData.budget);
    if (searchData.bedrooms) queryParams.append('bedrooms', searchData.bedrooms);
    
    // Navigate to search results page
    if ((!searchData.location || searchData.location.trim() === '') && !cityParam) {
      // city.preventDefault();
    //     city.stopPropagation();
        navigate('/buyer-dashboard/search?searchMode=upcoming-projects&project_type=upcoming');
        return;
    }
        navigate(`/searchresults?${queryParams.toString()}`);
      };

  const handleQuickSearch = (city) => {
    
    navigate(`/searchresults?location=${city}`);
  };

  const handleBackClick = () => {
    navigate('/');
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        const apiParams = {
          limit: 100
        };
        
        if (cityParam) {
          apiParams.location = cityParam;
        }
        
        const response = await propertiesAPI.list(apiParams);
        
        if (response.success && response.data && response.data.properties) {
          const backendProperties = response.data.properties.map(prop => {
            let imageUrl = prop.cover_image || 
                          (Array.isArray(prop.images) && prop.images.length > 0 ? prop.images[0] : null) ||
                          'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=500';
            
            return {
              id: prop.id,
              image: imageUrl,
              title: prop.title,
              price: parseFloat(prop.price),
              location: prop.location,
              bedrooms: prop.bedrooms || '0',
              bathrooms: prop.bathrooms || '0',
              area: parseFloat(prop.area),
              type: prop.property_type,
              status: prop.status === 'sale' ? 'For Sale' : (prop.status === 'rent' ? 'For Rent' : prop.status)
            };
          });
          
          setFilteredProperties(backendProperties);
        } else {
          setFilteredProperties([]);
        }
      } catch (error) {
        console.error('Error fetching properties:', error);
        setFilteredProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, [cityParam]);

 const handleViewAllClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate('/buyer-dashboard/search?searchMode=upcoming-projects&project_type=upcoming');
  };

  return (
    <div className="buyer-filtered-properties-page">
      {/* ========== SEARCH BAR WITH BACK BUTTON - START ========== */}


<BuyerSearchBar 
        
        title="Explore the Best Projects in Your City"
        subtitle="Search from thousands of verified projects across India"
        backgroundImage={homephoto}
      />



      
      {/* ========== SEARCH BAR WITH BACK BUTTON - END ========== */}

      {/* <div className="buyer-filtered-header">
        <h1>
          {cityParam ? `Residential Projects in ${cityParam}` : 'All Residential Projects'}
        </h1>
        <p className="buyer-filtered-count">
          {filteredProperties.length} {filteredProperties.length === 1 ? 'project' : 'projects'} found
        </p>
       <button 
              className="buyer-view-all-btn"
              onClick={handleViewAllClick}
              aria-label="View all properties"
            >
              View All
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
      </div> */}

      {/* {loading ? (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <p>Loading properties...</p>
        </div>
      ) : filteredProperties.length > 0 ? (
        <div className="buyer-filtered-properties-grid">
          {filteredProperties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
      ) : (
        <div className="buyer-no-properties">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          <h2>No Projects Found</h2>
          <p>
            {cityParam
              ? `We couldn't find any residential projects in ${cityParam} at the moment.`
              : 'No projects available.'}
          </p>
        </div>
      )} */}

      {/* Upcoming Projects Section */}
      <UpcomingProjectsSection />
    </div>
  );
};





export default CityProjects;